(function() {
  'use strict';

  class ComboQuickAddModal {
    constructor() {
      this.modal = document.getElementById('combo-quick-add-modal');
      if (!this.modal) return;

      this.backdrop = this.modal.querySelector('.combo-modal__backdrop');
      this.closeBtn = this.modal.querySelector('.combo-modal__close');
      this.thumbsContainer = this.modal.querySelector('.combo-modal__thumbs');
      this.mainImageWrapper = this.modal.querySelector('.combo-modal__image-wrapper');
      this.prevBtn = this.modal.querySelector('.combo-modal__nav--prev');
      this.nextBtn = this.modal.querySelector('.combo-modal__nav--next');
      this.titleEl = this.modal.querySelector('.combo-modal__title');
      this.priceCurrentEl = this.modal.querySelector('.combo-modal__price-current');
      this.priceCompareEl = this.modal.querySelector('.combo-modal__price-compare');
      this.priceBadgeEl = this.modal.querySelector('.combo-modal__price-badge');
      this.ratingValueEl = this.modal.querySelector('.combo-modal__rating-value');
      this.swatchesContainer = this.modal.querySelector('.combo-modal__swatches');
      this.sizesContainer = this.modal.querySelector('.combo-modal__sizes');
      this.variantIdInput = this.modal.querySelector('.combo-modal__variant-id');
      this.addToCartBtn = this.modal.querySelector('.combo-modal__add-btn');
      this.form = this.modal.querySelector('.combo-modal__form');
      this.colorOption = this.modal.querySelector('.combo-modal__option--color');
      this.sizeOption = this.modal.querySelector('.combo-modal__option--size');
      this.viewProductLink = this.modal.querySelector('.combo-modal__view-product');

      this.product = null;
      this.productUrl = null;
      this.currentImageIndex = 0;
      this.selectedOptions = {};
      this.displayImages = [];
      this.variantImages = {};
      this.hasSizeChart = false;
      this.swatchData = {};

      this.bindEvents();
    }

    bindEvents() {
      this.backdrop?.addEventListener('click', () => this.close());
      this.closeBtn?.addEventListener('click', () => this.close());
      this.prevBtn?.addEventListener('click', () => this.navigateImage(-1));
      this.nextBtn?.addEventListener('click', () => this.navigateImage(1));
      this.form?.addEventListener('submit', (e) => this.handleSubmit(e));

      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.isOpen()) this.close();
      });

      this.initSwipe();
    }

    initSwipe() {
      const wrapper = this.mainImageWrapper;
      if (!wrapper) return;

      let startX = 0;

      wrapper.addEventListener('touchstart', (e) => {
        startX = e.touches[0].clientX;
      }, { passive: true });

      wrapper.addEventListener('touchend', (e) => {
        const deltaX = e.changedTouches[0].clientX - startX;
        if (Math.abs(deltaX) > 40) {
          this.navigateImage(deltaX < 0 ? 1 : -1);
        }
      }, { passive: true });
    }

    isOpen() {
      return this.modal?.getAttribute('aria-hidden') === 'false';
    }

    async open(productHandle, productUrl) {
      console.log('ComboQuickAddModal.open called', { productHandle, productUrl });

      if (!productHandle && !productUrl) {
        console.warn('ComboQuickAddModal: No product handle or URL provided');
        return;
      }

      this.productUrl = productUrl || `/products/${productHandle}`;

      try {
        // Fetch product data
        const url = `/products/${productHandle}.js`;
        console.log('Fetching product from:', url);

        const response = await fetch(url);
        if (!response.ok) throw new Error(`Failed to fetch product: ${response.status}`);

        this.product = await response.json();
        console.log('Product loaded:', this.product.title, this.product);

        this.currentImageIndex = 0;
        this.selectedOptions = {};
        this.displayImages = this.product.images || [];

        /* Read swatch data embedded by Liquid — present on all sections that list products */
        this.variantImages = {};
        this.hasSizeChart = false;
        this.swatchData = {};
        const embeddedEl = document.querySelector(`[data-product-json="${productHandle}"]`);
        if (embeddedEl) {
          try {
            const ed = JSON.parse(embeddedEl.textContent);
            this.variantImages = ed.variant_images || {};
            this.hasSizeChart = ed.has_size_chart || false;
            this.swatchData = ed.swatches || {};
          } catch(e) {}
        }

        /* Fallback: fetch the product page and extract embedded swatch data (e.g. wishlist page) */
        if (Object.keys(this.swatchData).length === 0) {
          try {
            const pageResp = await fetch(`/products/${productHandle}`);
            if (pageResp.ok) {
              const html = await pageResp.text();
              const doc = new DOMParser().parseFromString(html, 'text/html');
              const el = doc.querySelector(`[data-product-json="${productHandle}"]`);
              if (el) {
                const ed = JSON.parse(el.textContent);
                this.swatchData = ed.swatches || {};
              }
            }
          } catch(e) {}
        }

        this.render();
        this.updateViewProductLink();

        /* Apply variant-specific images for the initially active color (preselect from URL if present) */
        const colorOptIdx = (this.product.options || []).findIndex(o => {
          const n = (typeof o === 'string' ? o : (o.name || '')).toLowerCase();
          return n.includes('color') || n.includes('colour');
        });
        if (colorOptIdx >= 0) {
          let targetColor = null;
          const urlMatch = (productUrl || '').match(/[?&]variant=(\d+)/);
          if (urlMatch) {
            const preVar = this.product.variants.find(v => v.id === parseInt(urlMatch[1]));
            if (preVar && preVar.options) targetColor = preVar.options[colorOptIdx];
          }
          if (!targetColor) {
            const activeSwatch = this.swatchesContainer.querySelector('.combo-modal__swatch.is-selected');
            if (activeSwatch) targetColor = activeSwatch.dataset.value;
          }
          if (targetColor) {
            this.swatchesContainer.querySelectorAll('.combo-modal__swatch').forEach(s => {
              s.classList.toggle('is-selected', s.dataset.value === targetColor);
            });
            this.selectedOptions[colorOptIdx] = targetColor;
            const colorNameEl = this.modal.querySelector('.combo-modal__selected-color-name');
            if (colorNameEl) colorNameEl.textContent = targetColor;
            this.updateImageForColor(targetColor);
            this.updateSizeAvailability();
            this.updateSelectedVariant();
          }
        }

        this.modal.setAttribute('aria-hidden', 'false');
        document.body.classList.add('combo-modal-open');

      } catch (error) {
        console.error('ComboQuickAddModal error:', error);
      }
    }

    close() {
      this.modal.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('combo-modal-open');
    }

    render() {
      if (!this.product) return;

      // Title
      this.titleEl.textContent = this.product.title;

      // Judge.me rating badge — clone from already-rendered page badge
      const jdgmBadge = this.modal.querySelector('.combo-modal__jdgm-badge');
      if (jdgmBadge) {
        jdgmBadge.setAttribute('data-id', this.product.id);
        const existingBadge = document.querySelector(`.jdgm-preview-badge[data-id="${this.product.id}"]:not(.combo-modal__jdgm-badge)`);
        if (existingBadge) {
          jdgmBadge.innerHTML = existingBadge.innerHTML;
        } else {
          jdgmBadge.innerHTML = '';
          if (window.jdgm && window.jdgm.customWidgetsInit) {
            window.jdgm.customWidgetsInit(jdgmBadge);
          }
        }
      }

      // Images
      this.renderImages();

      // Price
      this.updatePrice();

      // Options
      this.renderOptions();

      // Set initial variant
      this.updateSelectedVariant();
    }

    getProductUrlWithVariant() {
      const variantId = this.variantIdInput?.value;
      const baseUrl = (this.productUrl || '#').split('?')[0];
      return variantId ? `${baseUrl}?variant=${variantId}` : baseUrl;
    }

    updateViewProductLink() {
      if (this.titleEl) {
        this.titleEl.style.cursor = 'pointer';
        this.titleEl.onclick = () => { window.location.href = this.getProductUrlWithVariant(); };
      }

      const colorNameEl = this.modal.querySelector('.combo-modal__selected-color-name');
      if (colorNameEl) {
        colorNameEl.onclick = () => { window.location.href = this.getProductUrlWithVariant(); };
      }

      if (!this.viewProductLink) return;
      const text = window.__quickAddViewText;
      if (!text) {
        this.viewProductLink.style.display = 'none';
        return;
      }
      this.viewProductLink.textContent = text;
      this.viewProductLink.onclick = (e) => {
        e.preventDefault();
        window.location.href = this.getProductUrlWithVariant();
      };
      this.viewProductLink.style.display = 'flex';
    }

    renderImages() {
      this.displayImages = this.product.images || [];
      this._renderImageList();
    }

    _renderImageList() {
      const images = this.displayImages;

      if (images.length === 0) {
        this.thumbsContainer.innerHTML = '';
        this.mainImageWrapper.innerHTML = '<div style="background:#f0f0f0;width:100%;height:100%;"></div>';
        return;
      }

      // Thumbnails
      this.thumbsContainer.innerHTML = images.map((img, index) => `
        <button type="button" class="combo-modal__thumb ${index === 0 ? 'is-active' : ''}" data-index="${index}">
          <img src="${this.getImageUrl(img, '200x200')}" alt="${this.product.title}" loading="eager">
        </button>
      `).join('');

      // Add thumb click handlers
      this.thumbsContainer.querySelectorAll('.combo-modal__thumb').forEach(thumb => {
        thumb.addEventListener('click', () => {
          this.currentImageIndex = parseInt(thumb.dataset.index);
          this.updateMainImage();
        });
      });

      // Main image
      this.updateMainImage();

      // Constrain thumbs height to exactly match main image height (desktop only)
      if (window.innerWidth > 749) {
        requestAnimationFrame(() => {
          const mainImgWrapper = this.modal.querySelector('.combo-modal__image-wrapper');
          if (mainImgWrapper && mainImgWrapper.offsetHeight > 0) {
            this.thumbsContainer.style.maxHeight = mainImgWrapper.offsetHeight + 'px';
          }
        });
      } else {
        this.thumbsContainer.style.maxHeight = '';
      }
    }

    getImageUrl(src, size) {
      if (!src) return '';
      if (typeof src !== 'string') return '';

      // Separate query string so it doesn't interfere with extension/size detection
      const qIdx = src.indexOf('?');
      const base = qIdx >= 0 ? src.slice(0, qIdx) : src;
      const query = qIdx >= 0 ? src.slice(qIdx) : '';

      // Replace existing _NNNxNNN size suffix (e.g. _800x600 → _200x200)
      const replaced = base.replace(/_\d+x\d+(?=\.[^.]+$)/, `_${size}`);
      if (replaced !== base) return replaced + query;

      // No existing size — insert _NNNxNNN before the file extension
      const lastDot = base.lastIndexOf('.');
      if (lastDot > 0) {
        return base.slice(0, lastDot) + `_${size}` + base.slice(lastDot) + query;
      }

      return src;
    }

    updateMainImage() {
      const images = this.displayImages;
      if (images.length === 0) return;

      const imgSrc = images[this.currentImageIndex];
      this.mainImageWrapper.innerHTML = `
        <img src="${this.getImageUrl(imgSrc, '800x800')}" alt="${this.product.title}">
      `;

      // Update thumb active state
      this.thumbsContainer.querySelectorAll('.combo-modal__thumb').forEach((thumb, index) => {
        thumb.classList.toggle('is-active', index === this.currentImageIndex);
      });

      // Update nav visibility
      this.prevBtn.style.display = this.currentImageIndex > 0 ? 'flex' : 'none';
      this.nextBtn.style.display = this.currentImageIndex < images.length - 1 ? 'flex' : 'none';
    }

    navigateImage(direction) {
      const images = this.displayImages;
      this.currentImageIndex = Math.max(0, Math.min(images.length - 1, this.currentImageIndex + direction));
      this.updateMainImage();
    }

    updatePrice() {
      const variant = this.getSelectedVariant() || this.product.variants[0];
      if (!variant) return;

      const currentPrice = variant.price / 100;
      const comparePrice = variant.compare_at_price ? variant.compare_at_price / 100 : null;

      this.priceCurrentEl.textContent = `Rs.${currentPrice.toFixed(2)}`;

      if (comparePrice && comparePrice > currentPrice) {
        this.priceCompareEl.textContent = `Rs.${comparePrice.toFixed(2)}`;
        this.priceCompareEl.style.display = '';

        const discount = Math.round(((comparePrice - currentPrice) / comparePrice) * 100);
        this.priceBadgeEl.textContent = `Save ${discount}%`;
        this.priceBadgeEl.style.display = '';
      } else {
        this.priceCompareEl.style.display = 'none';
        this.priceBadgeEl.style.display = 'none';
      }
    }

    renderOptions() {
      const options = this.product.options || [];

      // Hide both option containers initially
      this.colorOption.style.display = 'none';
      this.sizeOption.style.display = 'none';
      const sizeChartLinkReset = this.sizeOption.querySelector('.combo-modal__size-chart');
      if (sizeChartLinkReset) sizeChartLinkReset.style.display = 'none';

      // If product has only one variant, no need to show options
      if (this.product.variants && this.product.variants.length === 1) {
        return;
      }

      options.forEach((option, optionIndex) => {
        // Handle both string and object format for options
        const optionName = (typeof option === 'string' ? option : (option.name || '')).toLowerCase();
        const values = this.getUniqueOptionValues(optionIndex);

        if (!values || values.length === 0) return;

        const sizeChartLink = this.sizeOption.querySelector('.combo-modal__size-chart');

        if (optionName.includes('color') || optionName.includes('colour')) {
          this.renderColorSwatches(values, optionIndex);
          this.colorOption.style.display = '';
        } else if (optionName.includes('size')) {
          this.renderSizeOptions(values, optionIndex);
          this.sizeOption.style.display = '';
          /* Only show Size Chart link if product metafield has one */
          if (sizeChartLink) sizeChartLink.style.display = this.hasSizeChart ? '' : 'none';
        } else {
          // Render as size-style buttons for other options — always hide Size Chart
          this.renderSizeOptions(values, optionIndex);
          this.sizeOption.style.display = '';
          if (sizeChartLink) sizeChartLink.style.display = 'none';
          const label = typeof option === 'string' ? option : (option.name || 'Option');
          this.sizeOption.querySelector('.combo-modal__option-label').textContent = `Select ${label}`;
        }
      });
    }

    getUniqueOptionValues(optionIndex) {
      const values = new Set();
      if (!this.product.variants) return [];
      this.product.variants.forEach(variant => {
        if (variant.options && variant.options[optionIndex] !== undefined && variant.options[optionIndex] !== null) {
          values.add(variant.options[optionIndex]);
        }
      });
      return Array.from(values);
    }

    renderColorSwatches(values, optionIndex) {
      this.swatchesContainer.innerHTML = values.map((value, index) => {
        const valueStr = String(value || '');
        const isSelected = index === 0;
        if (isSelected) this.selectedOptions[optionIndex] = valueStr;

        const entry = (this.swatchData && this.swatchData[valueStr]) || {};
        let innerContent = '';
        let styleAttr = '';

        if (entry.image) {
          innerContent = `<img src="${entry.image}" alt="${valueStr}" loading="lazy">`;
        } else if (entry.color) {
          styleAttr = `style="background:${entry.color}"`;
        }

        return `
          <button type="button"
                  class="combo-modal__swatch ${isSelected ? 'is-selected' : ''}"
                  data-option-index="${optionIndex}"
                  data-value="${valueStr}"
                  ${styleAttr}
                  title="${valueStr}">
            ${innerContent}
          </button>
        `;
      }).join('');

      this.swatchesContainer.querySelectorAll('.combo-modal__swatch').forEach(swatch => {
        swatch.addEventListener('click', () => this.selectOption(swatch, optionIndex));
      });

      const colorNameEl = this.modal.querySelector('.combo-modal__selected-color-name');
      if (colorNameEl && values.length > 0) colorNameEl.textContent = String(values[0] || '');
    }

    renderSizeOptions(values, optionIndex) {
      // Pre-select the first available size, not just index 0
      const firstAvailableIndex = values.findIndex((v) =>
        this.isOptionAvailable(optionIndex, String(v || ''))
      );
      const defaultIndex = firstAvailableIndex >= 0 ? firstAvailableIndex : 0;

      this.sizesContainer.innerHTML = values.map((value, index) => {
        const valueStr = String(value || '');
        const isSelected = index === defaultIndex;
        if (isSelected) this.selectedOptions[optionIndex] = valueStr;
        const isAvailable = this.isOptionAvailable(optionIndex, valueStr);

        return `
          <button type="button"
                  class="combo-modal__size ${isSelected ? 'is-selected' : ''}"
                  data-option-index="${optionIndex}"
                  data-value="${valueStr}"
                  ${!isAvailable ? 'disabled' : ''}>
            ${valueStr}
          </button>
        `;
      }).join('');

      this.sizesContainer.querySelectorAll('.combo-modal__size').forEach(size => {
        size.addEventListener('click', () => this.selectOption(size, optionIndex));
      });
    }

    selectOption(element, optionIndex) {
      const container = element.closest('.combo-modal__swatches, .combo-modal__sizes');
      container.querySelectorAll('.is-selected').forEach(el => el.classList.remove('is-selected'));
      element.classList.add('is-selected');

      this.selectedOptions[optionIndex] = element.dataset.value;
      this.updateSelectedVariant();
      this.updatePrice();

      // Update image and size availability if color changed
      if (element.closest('.combo-modal__swatches')) {
        this.updateImageForColor(element.dataset.value);
        this.updateSizeAvailability();
        const colorNameEl = this.modal.querySelector('.combo-modal__selected-color-name');
        if (colorNameEl) colorNameEl.textContent = element.dataset.value;
      }
    }

    isOptionAvailable(optionIndex, value) {
      if (!this.product.variants) return true;
      return this.product.variants.some(variant => {
        if (!variant.available) return false;
        if (!variant.options || variant.options[optionIndex] !== value) return false;
        // Also require all other currently-selected options to match
        return Object.entries(this.selectedOptions).every(([idx, selectedVal]) => {
          const i = parseInt(idx);
          if (i === optionIndex) return true;
          return variant.options[i] === selectedVal;
        });
      });
    }

    updateSizeAvailability() {
      const sizeBtns = this.sizesContainer?.querySelectorAll('.combo-modal__size');
      if (!sizeBtns || !sizeBtns.length) return;

      let selectedIsAvailable = false;

      sizeBtns.forEach(btn => {
        const optIdx = parseInt(btn.dataset.optionIndex);
        const val = btn.dataset.value;
        const available = this.isOptionAvailable(optIdx, val);
        btn.disabled = !available;
        if (btn.classList.contains('is-selected') && available) {
          selectedIsAvailable = true;
        }
      });

      // If the currently selected size is unavailable for the new color, jump to first available
      if (!selectedIsAvailable) {
        let firstAvailable = null;
        sizeBtns.forEach(btn => {
          if (!firstAvailable && !btn.disabled) firstAvailable = btn;
        });
        if (firstAvailable) {
          sizeBtns.forEach(btn => btn.classList.remove('is-selected'));
          firstAvailable.classList.add('is-selected');
          this.selectedOptions[parseInt(firstAvailable.dataset.optionIndex)] = firstAvailable.dataset.value;
        }
      }
    }

    getSelectedVariant() {
      if (!this.product.variants) return null;
      const selectedValues = Object.values(this.selectedOptions);
      return this.product.variants.find(variant => {
        if (!variant.options) return false;
        return variant.options.every((opt, i) => selectedValues[i] === undefined || opt === selectedValues[i]);
      });
    }

    updateSelectedVariant() {
      const variant = this.getSelectedVariant() || this.product.variants[0];
      if (variant) {
        this.variantIdInput.value = variant.id;
        this.addToCartBtn.disabled = !variant.available;
        this.addToCartBtn.querySelector('.combo-modal__add-btn-text').textContent =
          variant.available ? 'ADD TO CART' : 'SOLD OUT';
        this.updateViewProductLink();
      }
    }

    updateImageForColor(colorValue) {
      if (!colorValue) return;
      const colorLower = String(colorValue).toLowerCase();

      const variant = this.product.variants.find(v =>
        v.options && v.options.some(opt => String(opt || '').toLowerCase() === colorLower)
      );
      if (!variant) return;

      /* Use metafield images when available (embedded by Liquid in collection pages) */
      const metaImgs = this.variantImages[variant.id] || this.variantImages[String(variant.id)];
      if (metaImgs && metaImgs.length > 0) {
        this.displayImages = metaImgs;
        this.currentImageIndex = 0;
        this._renderImageList();
        return;
      }

      /* Fallback: match variant.featured_image against product images array */
      const featSrc = typeof variant.featured_image === 'string'
        ? variant.featured_image
        : (variant.featured_image && variant.featured_image.src) ? variant.featured_image.src : null;

      if (featSrc) {
        const filename = featSrc.split('/').pop().split('?')[0];
        const imgIndex = this.displayImages.findIndex(img => img && img.includes(filename));
        if (imgIndex >= 0) {
          this.currentImageIndex = imgIndex;
          this.updateMainImage();
        }
      }
    }

    async handleSubmit(e) {
      e.preventDefault();

      const variantId = this.variantIdInput.value;
      if (!variantId) return;

      const btn = this.addToCartBtn;
      const btnText = btn.querySelector('.combo-modal__add-btn-text');
      const originalText = btnText.textContent;

      btn.classList.add('is-loading');
      btnText.textContent = 'ADDING...';

      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1 })
        });

        if (response.ok) {
          btn.classList.remove('is-loading');
          btn.classList.add('is-added');
          btnText.textContent = 'ADDED!';

          // Update cart count
          this.updateCartCount();

          // Close modal after delay
          setTimeout(() => {
            this.close();
            btn.classList.remove('is-added');
            btnText.textContent = originalText;
          }, 1500);

        } else {
          throw new Error('Failed to add to cart');
        }
      } catch (error) {
        console.error('Add to cart error:', error);
        btn.classList.remove('is-loading');
        btnText.textContent = 'ERROR';
        setTimeout(() => {
          btnText.textContent = originalText;
        }, 2000);
      }
    }

    async updateCartCount() {
      try {
        const response = await fetch('/cart.js');
        const cart = await response.json();

        const cartCountElements = document.querySelectorAll('[data-cart-count], .cart-count, .cart-count-bubble');
        cartCountElements.forEach(el => {
          el.textContent = cart.item_count;
        });
      } catch (error) {
        console.error('Failed to update cart count:', error);
      }
    }
  }

  // Initialize modal
  window.comboQuickAddModal = new ComboQuickAddModal();

  // Global function to open modal
  window.openComboQuickAdd = function(productHandle, productUrl) {
    window.comboQuickAddModal.open(productHandle, productUrl);
  };
})();
